import { Column, Row, Section } from '../../components/Section';
import { Text } from '../../components/Text';

export const AgentsHeader = () => (
  <Section background="SLATE">
    <Row>
      <Column>
        <div className="max-w-screen-lg mx-auto">
          <Text.H1 className="text-2xl lg:text-5xl font-bold mb-2">
            Your satisfaction starts with finding{' '}
            <span className="text-blue-500">the right agent</span>
          </Text.H1>
          <Text.Body className="text-sm md:text-base lg:text-xl font-medium !text-gray-500">
            A licensed health insurance agent will find a plan that fits your
            personal needs and budget.
          </Text.Body>
        </div>
      </Column>
    </Row>
  </Section>
);
